var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 6.5C33.8249 6.5 34.9874 6.5 35.9411 6.75556C38.5293 7.44906 40.5509 9.47067 41.2444 12.0589C41.5 13.0126 41.5 14.1751 41.5 16.5V39.5C41.5 43.7004 41.5 45.8006 40.6825 47.4049C39.9635 48.8161 38.8161 49.9635 37.4049 50.6826C35.8006 51.5 33.7004 51.5 29.5 51.5H13.5C9.29961 51.5 7.19941 51.5 5.59507 50.6826C4.18386 49.9635 3.0365 48.8161 2.31745 47.4049C1.5 45.8006 1.5 43.7004 1.5 39.5V16.5C1.5 14.1751 1.5 13.0126 1.75556 12.0589C2.44906 9.47067 4.47067 7.44906 7.05886 6.75556C8.01261 6.5 9.17507 6.5 11.5 6.5M14 34L19 39L30.25 27.75M15.5 11.5H27.5C28.9001 11.5 29.6002 11.5 30.135 11.2275C30.6054 10.9878 30.9878 10.6054 31.2275 10.135C31.5 9.6002 31.5 8.90014 31.5 7.5V5.5C31.5 4.09987 31.5 3.39981 31.2275 2.86503C30.9878 2.39462 30.6054 2.01217 30.135 1.77249C29.6002 1.5 28.9001 1.5 27.5 1.5H15.5C14.0999 1.5 13.3998 1.5 12.865 1.77249C12.3946 2.01217 12.0122 2.39462 11.7725 2.86503C11.5 3.39981 11.5 4.09987 11.5 5.5V7.5C11.5 8.90014 11.5 9.6002 11.7725 10.135C12.0122 10.6054 12.3946 10.9878 12.865 11.2275C13.3998 11.5 14.0999 11.5 15.5 11.5Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.d270f7542cb03478855b16563356aa58.svg";
export { ForwardRef as ReactComponent };